import { render } from "./Container.vue?vue&type=template&id=88c65eb8&scoped=true&ts=true"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"

import "./Container.vue?vue&type=style&index=0&id=88c65eb8&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c65eb8"]])

export default __exports__